// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hdepte74hAkW1FKJ7ujh{flex-direction:row;height:100%;display:flex;position:relative;overflow-y:auto}.wAEkE3SIKCUI2KPNL8j1{flex-direction:column;width:760px;margin:40px auto;display:flex;position:relative}.dL_M8Ga6nQ4H46S1TJ46{margin-top:-24px;margin-bottom:40px}.N6Sf7BySizQlGsTjxM_E{margin-top:24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `hdepte74hAkW1FKJ7ujh`,
	"content": `wAEkE3SIKCUI2KPNL8j1`,
	"paymentErrorAlert": `dL_M8Ga6nQ4H46S1TJ46`,
	"dropdownCards": `N6Sf7BySizQlGsTjxM_E`
};
export default ___CSS_LOADER_EXPORT___;
